import { memo, useCallback, useState } from 'react'

interface ResizeHandleProps {
  label: string
  onDelta: (delta: number) => void
}

export const ResizeHandle = memo(function ResizeHandle({ label, onDelta }: ResizeHandleProps) {
  const [active, setActive] = useState(false)

  const handleMouseDown = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    setActive(true)
    let lastX = event.clientX

    const handleMove = (moveEvent: MouseEvent) => {
      onDelta(moveEvent.clientX - lastX)
      lastX = moveEvent.clientX
    }

    const handleUp = () => {
      setActive(false)
      document.removeEventListener('mousemove', handleMove)
      document.removeEventListener('mouseup', handleUp)
    }

    document.addEventListener('mousemove', handleMove)
    document.addEventListener('mouseup', handleUp)
  }, [onDelta])

  const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return
    event.preventDefault()
    onDelta(event.key === 'ArrowLeft' ? -12 : 12)
  }, [onDelta])

  return (
    <button
      type="button"
      className={`tp-resize-handle${active ? ' is-active' : ''}`}
      aria-label={label}
      onKeyDown={handleKeyDown}
      onMouseDown={handleMouseDown}
    />
  )
})
